<template>
    <div style="background: linear-gradient(180deg, #ffffff 0%, #e6e2fe 60%);" class="py-12">
        <ContentWrapper class=" text-center">
            <div class="text-3xl font-headings">One App for Everything</div>

            <div class="py-4 mx-auto max-w-3xl">
                Everything your attendees need to engage, everything your exhibitors need to connect, and everything your staff needs to manage—all in one beautifully designed mobile app and web portal.
            </div>

            <div class="grid grid-cols-1 md:grid-cols-4 gap-6 mt-8">
                <div v-for="(deployment, index) in deployments" :key="index" class="p-4 bg-white rounded-lg shadow-md">
                    <div class="font-semibold mb-1">{{ deployment.title }}</div>
                    <div class="text-sm text-gray-600">{{ deployment.description }}</div>
                </div>
            </div>
            
        </ContentWrapper>
    </div>
</template>
<script setup>
import ContentWrapper from '../../Layouts/ContentWrapper.vue';

const deployments = [
    {
        title: 'Attendees',
        description: 'Search, Scan QR codes, view schedules, maps, and more'
    },
    {
        title: 'Sponsors & Exhibitors',
        description: 'View sponsor and exhibitor information, connect with them, and more'
    },
    {
        title: 'Staff',
        description: 'Manage attendees, exhibitors, and more from your device'
    },
    {
        title: 'Speakers',
        description: 'Manage attendees, exhibitors, and more from your device'
    }
]
</script>